import { TehnicalInspectionRow } from "services/api/calculations/tehnicalinspection/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";


export const CALCULATION_TEHNICAL_INSPECTION_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: TehnicalInspectionRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.vehicleGroupName.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.residualvalue.search.vehiclegroupname",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.vehicleGroupName}</div>
        </div>
      );
    },
  },
  {
    title: "Cijena",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.price} €</div>
        </div>
      );
    },
  },
];
